import api from "./apiMethods";
import { getCookie } from '../utils/CookiesUtil';

const { REACT_APP_API_URL } = process.env;

export const getCategories = async ({validatePermissions = 'true', filterActive = 'true'}) => {
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/memberships/get-membership-types`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
      "validate_permissions": validatePermissions,
      "filter_active": filterActive,
    },
  };
  return api(request);
};

export const updateCategoryStatus = async (idCategory, status) => {

  const payload = {
    "is_activate": status,
    "id_membership_types": idCategory
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/memberships/de-activate-membership-types`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const createCategory = async (name, liberDiscount, thirdDiscount, productBuyDiscount, storageDiscount, supplierNotification, clientNotification) => {

  const payload = {
    "is_update": false,
    "membership_name": name,
    "liber_discount": Math.floor(parseInt(liberDiscount)),
    "third_discount": Math.floor(parseInt(thirdDiscount)),
    "product_buy_discount": Math.floor(parseInt(productBuyDiscount)),
    "storage_discount": Math.floor(parseInt(storageDiscount)),
    "supplier_notification": supplierNotification,
    "client_notification": clientNotification,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/memberships/insert-update-membership-types`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const updateCategory = async (idCategory, name, liberDiscount, thirdDiscount, productBuyDiscount, storageDiscount, supplierNotification, clientNotification) => {

  const payload = {
    "id_membership_type": idCategory,
    "is_update": true,
    "membership_name": name,
    "liber_discount": parseInt(liberDiscount),
    "third_discount": parseInt(thirdDiscount),
    "product_buy_discount": parseInt(productBuyDiscount),
    "storage_discount": parseInt(storageDiscount),
    "supplier_notification": supplierNotification,
    "client_notification": clientNotification,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/memberships/insert-update-membership-types`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};